<template>
  <div>
    <v-card>
      <div class="pa-2">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="6" xs="6"
            ><v-card-title
              class="subtitle-1 pl-1"
              v-if="this.totalAffiliated.length != 0"
            >
              <v-icon left>mdi-account-group</v-icon>
              {{ $t("totalAffiliates") }}:
              {{ totalAffiliated.total }}
            </v-card-title></v-col
          >
          <v-spacer></v-spacer>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="elevation-2"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:no-data>
          <div>{{ $t("noSearchPerformed") }}</div>
        </template>

        <template v-slot:item.id="{ item }">
          <v-btn @click="$copy(item.id)" small>{{ item.id }}</v-btn>
        </template>

        <template v-slot:item.data_cadastro="{ item }">
          <div class="caption">
            {{ item.data_cadastro }}
          </div>
        </template>

        <template v-slot:item.nome="{ item }">
          <div class="caption">
            {{ item.nome }}
          </div>
        </template>

        <template v-slot:item.ultimo_login="{ item }">
          <div class="caption">
            {{ item.ultimo_login }}
          </div>
        </template>

        <!-- <template v-slot:item.saldo_bonus="{ item }">
          <div class="caption">
            {{ $t("labelCurrency") }}
            {{ item.saldo_bonus }}
          </div>
        </template>

        <template v-slot:item.saldo_deposito="{ item }">
          <div class="caption">
            {{ $t("labelCurrency") }}
            {{ item.saldo_deposito }}
          </div>
        </template> -->

        <template v-slot:item.status="{ item }">
          <v-chip class="caption" outlined :color="getColor(item.status)">{{
            statusUI(item.status)
          }}</v-chip>
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      center
      bottom
      :timeout="5000"
      color="warning"
    >
      {{ msg }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Notification from "@/components/notification/notification";
export default {
  name: "views-dashboard-agent-financial-listAffiliates",
  components: {
    Notification,
  },
  data: () => ({
    search: "",
    items: [],
    totalAffiliated: [],
    snackbar: false,
    msg: "",
  }),
  computed: {
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    rangeDate() {
      return this.$store.state.rangeGlobal.date;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    headers() {
      return [
        {
          text: "ID",
          value: "id",
        },
        {
          text: this.$t("dateRegistration"),
          value: "data_cadastro",
        },
        {
          text: this.$t("name"),
          value: "nome",
        },
        // {
        //   text: this.$t("bonusBalance"),
        //   value: "saldo_bonus",
        // },
        // {
        //   text: this.$t("depositBalance"),
        //   value: "saldo_deposito",
        // },
        {
          text: "Status",
          value: "status",
        },
        {
          text: this.$t("lastAccess"),
          value: "ultimo_login",
        },
      ];
    },
  },
  mounted() {
    this.getTotal();
    this.$store.commit("setGroupExport", "");
  },
  watch: {
    saveFilters(val) {
      val && this.listAffiliates();
    },
  },
  methods: {
    async listAffiliates() {
      const body = {
        ...this.rangeDate,
        export: this.exportDoc,
      };

      let response;
      try {
        // Request Download DOC (Excel)
        if (this.exportDoc) {
          const extension = this.exportDoc;
          response = await this.$exportDocument(
            "/agent/affiliates/list",
            body,
            extension,
            this.rangeDate
          );
        } else {
          response = await this.$request.post("/agent/affiliates/list", body);
          // .reverse() para inverter a ordem do array e os ultimos jogadores (mais recentes)
          // aparecerem nas primeiras posições da table
          this.items = response.data.dados;
          this.items.reverse();
          this.items.forEach((item) => {
            item.data_cadastro = item.data_cadastro
              ? new Date(item.data_cadastro.replace(" ", "T")).toLocaleString()
              : this.$t("noRegister");
            item.ultimo_login =
              item.ultimo_login == null
                ? this.$t("noRegister")
                : new Date(item.ultimo_login.replace(" ", "T")).toLocaleString();
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTotal() {
      // Total Affiliates
      await this.$axios
        .get("/agent/affiliates/totalAffiliated")
        .then((response) => {
          this.totalAffiliated = response.data.dados[0];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    statusUI(status) {
      const obj = {
        0: this.$t("suspended"),
        1: this.$t("active"),
        // Status 2 não é mais utilizado,
        // Mas ainda há alguns usuários que aparecem
        // com esse status - tratamento para não quebrar a table
        2: this.$t("suspended"),
        3: this.$t("accountDisabled"),
        4: this.$t("blocked"),
        5: this.$t("accountConfirmation"),
        6: this.$t("disabledByLoginAttempts"),
      };
      return obj[status];
    },
    getColor(status) {
      if (status == 0) return "danger";
      if (status == 1) return "success";
      if (status == 2) return "danger";
      if (status == 3) return "danger";
      if (status == 4) return "grey";
      if (status == 5) return "warning";
      if (status == 6) return "deep-orange darken-1";
    },
  },
};
</script>
